import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  errorMsg: null,
};

const signInSlice = createSlice({
  name: "signIn",
  initialState,
  reducers: {
    signInError: (state, { payload }) => {
      state.errorMsg = payload;
    },
  },
});

export const { signInError } = signInSlice.actions;
export default signInSlice.reducer;
